import { FormField } from 'ui/formField';
import { WebPushContentDefinition } from 'modules/graphql/types';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { FieldNames, MediumDataKey, TemplateEditViews } from '../../common/types';
import { constructFieldErrors } from '../../common/utils';
import { UrlInputField } from '../../common/components';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useErrorValidationContext } from '../../context/ErrorValidationContext';
import { constructErrorInlineText } from '../../common/ErrorInlineText';

export const displayContent = {
  label: 'Click Location',
  helperText: 'Navigates users to the link when clicked. The link provided must be HTTPS.',
};

export const WEB_PUSH_CLICK_LOCATION: MediumDataKey = 'clickAction';

export const WebPushLocationField = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();
  const webPushData = (liveTemplate?.mediumData || {}) as WebPushContentDefinition;
  const isEditModeVisible = view === TemplateEditViews.preview || isEditMode;

  const { hasError: hasClickLocationError } = constructFieldErrors({
    contentErrors: localeContentErrors,
    contentWarnings: localeContentWarnings,
    fieldName: FieldNames.CLICK_ACTION,
  });
  const clickLocationErrorText = constructErrorInlineText({
    condition: isEditModeVisible,
    hasError: hasClickLocationError,
  });

  return (
    <FormField
      data-test="web-push-location-field"
      isHorizontalLayout
      helpText={isEditModeVisible ? displayContent.helperText : ''}
      labelText={displayContent.label}
      hasError={hasClickLocationError}
      errorText={clickLocationErrorText}
    >
      <UrlInputField
        hasError={hasClickLocationError}
        id={WEB_PUSH_CLICK_LOCATION}
        inputValue={webPushData.clickAction}
        onChangeHandler={(newLocationUrl) => setCurrentMediumField('clickAction', newLocationUrl)}
      />
    </FormField>
  );
};
